<template>
    <div>

        <v-tooltip top>
            <div slot="activator" @click="LoadFileManager" class="file-input-box">
                {{label}}
                <v-chip style="direction: ltr" v-if="value.length>0">{{value}}</v-chip>
            </div>
            <span v-if="value.length>0 && UserID !== 0 ">
                <img style="max-height: 120px" :src="`/reseller_privates/`+UserID+`/`+ OriginalFile" :alt="value">
            </span>
        </v-tooltip>
        <v-dialog
                v-model="fileManager"
                width="100%"
        >
            <v-card>
                <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                >
                    مدیریت فایل‌ها
                    <v-spacer></v-spacer>
                    <v-btn slot="activator" @click="fileManager=false" icon>
                        <v-icon>close</v-icon>
                    </v-btn>

                </v-card-title>
                <v-card-text>
                    <v-layout class="mt-2" row wrap>
                        <v-flex xs4 md2 lg2 v-for="(file,i) in files" v-bind:key="i">
                            <v-card
                                    class="elevation-4 filemanager-box mx-auto mx-2 my-2 px-1 py-1"
                                    :color="file.name === OriginalFile?'green':'white'"
                            >
                                <v-btn @click="RemoveFile(i)" color="red" icon class="remove-btn-file">
                                    <v-icon color="white">close</v-icon>
                                </v-btn>
                                <v-tooltip top>
                                    <v-img
                                            @click="fileClick(basePath+file.name)"
                                            slot="activator"
                                            :aspect-ratio="16/16"
                                            :src="`/reseller_privates/`+UserID+`/`+file.name"
                                    ></v-img>
                                    <span class="text-small">
                                       {{file.name}}
                                    </span>
                                </v-tooltip>

                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-tooltip top>
                        <v-progress-circular size="64" slot="activator" class="px-5"
                                             :value="totalSizeBar"></v-progress-circular>
                        <span>
                            {{toPersianDigit(totalSizeMB)}} مگابایت
                            از ۱۰۰ مگابایت مجاز پر شده است.
                        </span>
                    </v-tooltip>
                    <div class="flex-grow-1"></div>
                    <v-flex xs12>
                        <ImageSelect
                                v-model="uploadFile"
                                format="png,jpeg,jpg,gif,svg"
                                label="آپلود فایل جدید"
                                :height="0"
                                :width="0"
                                :max-size="0"
                                style="width: 100%;"
                        ></ImageSelect>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
                :bottom="snackbar.y === 'bottom'"
                :color="snackbar.color"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :right="snackbar.x === 'right'"
                :timeout="snackbar.timeout"
                :top="snackbar.y === 'top'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn @click.native="snackbar.snackbar = false" dark flat icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import ImageSelect from './ImageSelect.vue';

export default {
  components: {
    ImageSelect
  },
  props: {
    label: String,
    value: String,
    basePath: String,
  },
  data: function () {
    return {
      UserID: 0,
      OriginalFile: '',
      fileManager: false,
      files: [],
      uploadFile: null,
      deleteFile: '',
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
    };
  },
  computed: {
    totalSizeBar: function () {
      let size = 0;
      this.files.forEach(f => {
        size += f.size;
      });
      size = Math.round((size) / (1024 * 1024));
      return size;
    },
    totalSizeMB: function () {
      let size = 0;
      this.files.forEach(f => {
        size += f.size;
      });
      size = Math.round((size / (1024 * 1024)) * 100) / 100;
      return size;
    }
  },
  watch: {
    value: function (filename) {
      this.OriginalFile = filename.replace(this.basePath, '', -1);
    },
    uploadFile: function (data) {
      if (data === null) {
        return;
      }
      let formData = new FormData();
      formData.append('file', data);
      this.axios.post('/reseller/upload_assets', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        this.files.push(response.data);
        this.snackbar.text = 'با موفقیت ذخیره شده!';
        this.snackbar.color = 'green';
        this.snackbar.snackbar = true;
      }).catch(error => {
        if (typeof error.response.data.message !== undefined) {
          this.snackbar.text = error.response.data.message;
          this.snackbar.color = 'red';
          this.snackbar.snackbar = true;
        }
      });
    }
  },
  mounted: function () {
    this.OriginalFile = this.value.replace(this.basePath, '', -1);
  },
  methods: {
    fileClick (path) {
      if (this.OriginalFile === path) {
        this.OriginalFile = '';
        this.$emit('input', this.OriginalFile);
        return;
      }
      this.OriginalFile = path;
      this.$emit('input', this.OriginalFile);
    },
    RemoveFile: function (i) {
      let name = this.files[i].name;
      if (this.deleteFile !== name) {
        this.snackbar.text = 'برای اطمینان دوباره کلیک کنید.';
        this.snackbar.color = 'blue';
        this.snackbar.snackbar = true;
        this.deleteFile = name;
        return;
      }
      this.axios.get('/reseller/remove_file/?file=' + encodeURI(name))
        .then(() => {
          this.files.splice(i, 1);
          this.snackbar.text = 'باموفقیت حذف شد!';
          this.snackbar.color = 'green';
          this.snackbar.snackbar = true;
        }).catch(error => {
          if (typeof error.response.data.message !== undefined) {
            this.snackbar.text = error.response.data.message;
            this.snackbar.color = 'red';
            this.snackbar.snackbar = true;
          }
        });

    },
    LoadFileManager: function () {
      this.fileManager = true;
      this.axios.get('/reseller/list_of_files/')
        .then(response => {
          this.UserID = response.data.user_id;

          if (response.data.files.length > 0) {
            this.files = response.data.files;
          }

        }).catch(error => {
          if (typeof error.response.data.message !== undefined) {
            this.snackbar.text = error.response.data.message;
            this.snackbar.color = 'red';
            this.snackbar.snackbar = true;
          }
        });

    }
  }
};
</script>

<style scoped>
    .file-input-box {
        padding: 1rem;
        width: 100%;
        cursor: pointer;
        color: #7a7a7a;
        border: 1px dashed #b6b6b6;
        border-radius: .3rem;
        text-align: center;
        font-weight: bold;
    }

    .filemanager-box {
        cursor: pointer;
        position: relative;
    }

    .remove-btn-file {
        position: absolute;
        top: 10px;
        bottom: 20px;
        z-index: 99999;
        display: none;
    }

    .filemanager-box:hover .remove-btn-file {
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/FileManager.vue